import metadata from '../../../metadata.json';
import './HotWaterRatioInput.css';

/** Per-type default share (0-100) of metadata.json, used when neither the usage nor the equipment sets one. */
export const getDefaultHotWaterRatioPercent = (equipmentType) =>
  metadata.default_hot_water_ratio?.[equipmentType] ?? 0;

/** Where the effective share comes from (cf. waterPricing.js:getHotWaterRatioWithSource). */
export const HOT_WATER_SOURCE_LABELS = {
  usage: 'saisie pour cet usage',
  equipment: "héritée de l'équipement",
  default: 'valeur par défaut du type',
  not_connected: "équipement non raccordé à l'eau chaude",
};

/**
 * 0-100% hot water ratio input: slider + numeric readout + shortcuts.
 * Hot water = water leaving the heater (a 38-40 °C shower is ~65 % hot water).
 * Controlled from the outside: `value` is the value to DISPLAY (resolved by the
 * caller — the document's explicit share, or the inherited one when absent).
 * `onChange(newValue)` fires only on real user interaction, so the caller can
 * distinguish "never touched" (don't write the field) from "user explicitly chose
 * N%" (write it, even if N equals the inherited value).
 *
 * Shortcuts: 0 %, the per-type default of `equipmentType` (when given), 100 %.
 * `presets` optionally overrides them with scenario-specific ones ({ value, label, icon }).
 */
const HotWaterRatioInput = ({ value, onChange, disabled, presets, equipmentType }) => {
  const typeDefault = equipmentType ? getDefaultHotWaterRatioPercent(equipmentType) : null;
  const defaultShortcuts = [
    { value: 0, label: "Pas d'eau chaude" },
    ...(typeDefault != null && typeDefault !== 0 && typeDefault !== 100 ? [{ value: typeDefault, label: `Valeur type (${typeDefault} %)` }] : []),
    { value: 100, label: 'Eau chaude pure' },
  ];
  const shortcuts = presets && presets.length > 0 ? presets : defaultShortcuts;
  return (
    <div className="hwr-wrapper">
      <div className="hwr-header">
        <span className="hwr-value">{value} %</span>
      </div>
      <input
        type="range"
        className="hwr-range-input"
        min={0}
        max={100}
        step={1}
        value={value}
        disabled={disabled}
        onChange={e => onChange(Number(e.target.value))}
      />
      <div className="hwr-shortcuts">
        {shortcuts.map(s => (
          <button
            key={s.label}
            type="button"
            className={`hwr-shortcut-btn ${value === s.value ? 'hwr-shortcut-btn--active' : ''}`}
            onClick={() => onChange(s.value)}
            disabled={disabled}
          >
            {s.icon && <span className="hwr-shortcut-icon">{s.icon}</span>}
            {s.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default HotWaterRatioInput;
